import React from "react";
import { Layout } from "antd";

import HeaderMenu from "../../HeaderMenu/HeaderMenu";
import BatchLineTable from "./BatchLineTable";
import { PageHeader } from "@ant-design/pro-layout";

const { Content } = Layout;

const BatchLineTablePage = () => {
  return (
    <>
      <HeaderMenu>
        <PageHeader title={<h1>Batch lines</h1>} />
      </HeaderMenu>

      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <BatchLineTable />
      </Content>
    </>
  );
};

export default BatchLineTablePage;
